'use client';
import { createModuleEmitter } from './moduleEmitter';

/** JSON is parsed by the shell; the voice controller validates each event's payload. */
export interface VoiceRingEvent {
  type: 'voice_ring' | 'voice_ring_end';
  data: unknown;
}
const events = createModuleEmitter<VoiceRingEvent>();
export const subscribeVoiceRingEvents = events.subscribe;
export const emitVoiceRingEvent = events.emit;
